<!-- 跑马灯组件，此组件不需要预置dom，只需在创建的时候指定挂载dom（即要在哪个dom里面跑） -->
<template>
  <div class="bjy-sidebar" :class="{ 'bjy-active': show }">
    <div @click="show = !show" class="bjy-toggle-btn">文档列表</div>
    <div class="bjy-doc-list"></div>
    <div class="class_button">
      <el-button type="primary" size="small" @click="openDiglog">上传课件<i
          class="el-icon-upload el-icon--right"></i></el-button>
    </div>
    <div id="bjy-document-manage"></div>
  </div>
</template>

<script>
let catalogue = null
let manage = null
let eventEmitter = BJY.eventEmitter;
export default {
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    catalogue = BJY.Catalogue.create({
      element: $(".bjy-doc-list"),
      thumbnailWidth: 100,
      hasWhiteboard: true,
    });
    // 上传文件最大字节
    var MAXSIZE = 1000000 * 5;
    // 创建文档管理组件
    let docManage = BJY.DocumentManage.create({
      // 父容器
      element: $('#bjy-document-manage'),
      // 文档操作按钮是图标还是文字
      needIconButton: true,
      // 上传文件最大字节
      maxSize: MAXSIZE,
      // 上传失败回调
      onFileUploadFail: function (data) {
        // data.isPPT 上传的文件是否是 PPT
        alert('上传失败');
      },
      // 文件大小错误
      onFileSizeError: function (data) {
        // data.isPPT 上传的文件是否是 PPT
        alert('上传文件太大');
      },
      // 文件类型错误
      onFileTypeError: function (data) {
        // data.isPPT 上传的文件是否是 PPT
        alert('文件类型错误');
      },
      // 文件名错误
      onFileNameError: function (data) {
        // data.isPPT 上传的文件是否是 PPT
        alert('文件名错误');
      },
      // 删除文档回调
      onDocDeleteClick: function (data) {
        // data.index  文档在列表中的索引
        // data.doc 文档对象
        docManage.deleteDoc(data)
      },
      // 普通文档点击播放
      onFileOpenClick: function (doc) {
        // 需对接课件目录组件 展开对应文档
      },
      // 媒体文件点击播放
      onMediaFileOpenClick: function (doc) {
        // 需对接媒体播放组件mediaPlayer
        eventEmitter.trigger("toggle_media_player");
      }
    });
  },
  methods: {
    //打开上传课件
    openDiglog() {
      const diglogStatus =$('#bjy-document-manage').css('display')
      $('#bjy-document-manage').css({
        display: diglogStatus==='none'?'block':'none'
      })
    }
  }
};

</script>

<style lang="scss">
.bjy-sidebar {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: -1;
  left: 0;
  width: 160px;
  background: #fff;
  box-shadow: 5px -5px 5px 5px #aaa;

  &.bjy-active {
    left: -160px;
  }

  #bjy-document-manage {
    position: fixed;
    width: 50%;
    height: 50%;
    top: 50%;
    /* 向上移动元素高度的50% */
    left: 50%;
    /* 向左移动元素宽度的50% */
    transform: translate(-50%, -50%);
    /* 使用变换将元素自身中心点与容器中心点对齐 */
    display: none;
  }

  .bjy-catalogue.bjy-detail .bjy-page-list {
    padding-bottom: 50px;
  }

  .class_button {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translate(-50%);
    height: 30px;
  }

  .bjy-toggle-btn {
    position: absolute;
    left: -24px;
    top: 100px;
    width: 24px;
    word-break: break-all;
    font-size: 14px;
    line-height: 20px;
    padding: 10px 0;
    text-align: center;
    background: #fff;
    color: #4a4a4a;
    border: 1px solid #4a4a4a;
    cursor: pointer;
  }
}</style>
